function Diamond() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h2 class="mt-5">Diamond</h2>
        <p class="lead">
          Here comes the Diamond App.
        </p>
      </div>
    </main>
    </>
  );
}

export default Diamond;